import { httpsCallable } from 'firebase/functions';
import firebaseConfig from '../../config';

const { databaseId } = firebaseConfig;

function AdminFactory(firebase) {
  const createUser = async ({
    name,
    email,
    company,
    sessionsUserHasAccessTo
  }) => {
    const createUserCallable = httpsCallable(
      firebase.functions,
      'admin-createUser'
    );
    return createUserCallable({
      name,
      email,
      company,
      sessionsUserHasAccessTo,
      databaseId
    });
  };

  const grantModeratorPermissions = async ({ uids, sessionId }) => {
    const grantModeratorPermissionsCallable = httpsCallable(
      firebase.functions,
      'admin-grantModeratorPermissions'
    );
    return grantModeratorPermissionsCallable({
      uids,
      sessionId,
      databaseId
    });
  };

  const removeModeratorPermissions = async ({ uids, sessionId }) => {
    const removeModeratorPermissionsCallable = httpsCallable(
      firebase.functions,
      'admin-removeModeratorPermissions'
    );
    return removeModeratorPermissionsCallable({
      uids,
      sessionId,
      databaseId
    });
  };

  const grantUserSessionAccess = async ({ uids, sessionId }) => {
    const grantUserSessionAccessCallable = httpsCallable(
      firebase.functions,
      'admin-grantUserSessionAccess'
    );
    return grantUserSessionAccessCallable({
      uids,
      sessionId,
      databaseId
    });
  };

  const removeUserSessionAccess = async ({ uids, sessionId }) => {
    const removeUserSessionAccessCallable = httpsCallable(
      firebase.functions,
      'admin-removeUserSessionAccess'
    );
    return removeUserSessionAccessCallable({
      uids,
      sessionId,
      databaseId
    });
  };

  const generateSessionCommentsReport = async () => {
    const generateSessionCommentsReportCallable = httpsCallable(
      firebase.functions,
      'admin-generateSessionCommentsReport'
    );
    return generateSessionCommentsReportCallable({
      databaseId
    });
  };

  return {
    createUser,
    grantModeratorPermissions,
    removeModeratorPermissions,
    grantUserSessionAccess,
    removeUserSessionAccess,
    generateSessionCommentsReport
  };
}

export default AdminFactory;
